function hasRecipientProcessingActivityAccess() {
  return true;
}

export default {
  hasRecipientProcessingActivityAccess,
};
